/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react"
import { Button, Card, Col, Container, Row } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { Prompt, useHistory, useParams } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import ComboBox from "../../../components/ComboBox"
import { T区分マスタ } from "../../../components/ComboBox/KubunComboBox"
import { showInfoToast } from "../../../components/CustomToast"
import TextInput from "../../../components/InputWrapper/TextInput"
import MasterRegisterFormRow from "../../../components/MasterRegisterFormRow"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import CONSTANT from "../../../constant"
import { setAlerts, setWarningAlerts } from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import SiharaisakiService from "../../../service/master/siharaisaki/siharaisakiService"
import { 区分分類コード } from "../../../constant/enum/codes"
import { TApiResponse } from "../../../service/TApiResponse"
import util from "../../../ts/util"
import { TWijmoComboBox } from "../../../type/wijmoComponents"
import KubunService from "../../../service/master/kubun/kubunService"
import {
  TSiharaisakiRegisterPostReq,
  TSiharaisakiUpdatePutReq,
} from "../../../service/master/siharaisaki/TSiharaisaki"
import Ajv, { ErrorObject } from "ajv"
import ajvErrors from "ajv-errors"
import {
  TSiharaisakiRegisterPostReqSchema,
  TSiharaisakiUpdatePutReqSchema,
} from "../../../service/master/siharaisaki/siharaisakiSchema"
import { RootState } from "../../../globalStore/rootreducer"
import { メニューコード } from "../../../constant/menuCode"

/**
 * 支払先マスタ
 * @returns
 */
const MasterSiharaisakiRegister = () => {
  const history = useHistory()
  const { id } = useParams<{ id: string }>()
  const disPatch: AppDispatch = useDispatch()

  const 読取専用フラグ = useSelector(
    (rootState: RootState) =>
      rootState.menu.menuPage.find(
        (m) => m.メニューコード === メニューコード.マスタ管理.支払先マスタ登録
      )?.読み取り専用フラグ
  )

  // 戻る確認ダイアログ表示フラグ
  const isPrompt = useRef(false)

  //#region [state]

  // 表示項目のstate
  const [支払先コード, set支払先コード] = useState<string>()
  const [支払先区分コード, set支払先区分コード] = useState<string | null>()
  const [支払先名, set支払先名] = useState<string>()
  const [支払先略称, set支払先略称] = useState<string>()
  const [郵便番号, set郵便番号] = useState<string>()
  const [住所１, set住所１] = useState<string>()
  const [住所２, set住所２] = useState<string>()
  const [住所３, set住所３] = useState<string>()
  const [電話番号, set電話番号] = useState<string>()
  const [FAX番号, setFAX番号] = useState<string>()
  const [支払先担当者, set支払先担当者] = useState<string>()
  const [インボイス登録番号, setインボイス登録番号] = useState<string>()

  const [最終更新日時, set最終更新日時] = useState<string>()
  const [最終更新ID, set最終更新ID] = useState<string>()

  const [区分ItemSource, set区分ItemSource] = useState<T区分マスタ[]>()

  //　エラー表示用フラグ
  const [isInvalid支払先コード, setIsInvalid支払先コード] =
    useState<boolean>(false)
  const [isInvalid支払先区分コード, setIsInvalid支払先区分コード] =
    useState<boolean>()
  const [isInvalid支払先名, setIsInvalid支払先名] = useState<boolean>(false)
  const [isInvalid支払先略称, setIsInvalid支払先略称] = useState<boolean>(false)
  const [isInvalid郵便番号, setIsInvalid郵便番号] = useState<boolean>(false)
  const [isInvalid住所１, setIsInvalid住所１] = useState<boolean>(false)
  const [isInvalid住所２, setIsInvalid住所２] = useState<boolean>(false)
  const [isInvalid住所３, setIsInvalid住所３] = useState<boolean>(false)
  const [isInvalid電話番号, setIsInvalid電話番号] = useState<boolean>(false)
  const [isInvalidFAX番号, setIsInvalidFAX番号] = useState<boolean>(false)
  const [isInvalid支払先担当者, setIsInvalid支払先担当者] =
    useState<boolean>(false)
  const [isInvalidインボイス登録番号, setIsInvalidインボイス登録番号] =
    useState<boolean>(false)

  //#region [comboboxState]

  // 支払先区分
  const [支払先区分ComboBox, set支払先区分ComboBox] = useState<TWijmoComboBox<
    T区分マスタ["区分コード"],
    T区分マスタ
  > | null>(null)
  const [支払先区分IsLoadEnded, set支払先区分IsLoadEnded] =
    useState<boolean>(false)

  //#endregion

  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)

  //#endregion

  //#region [method]
  /**
   * データ取得
   */
  const getData = async (id: string) => {
    const service = new SiharaisakiService()

    try {
      const res = await service.get(id)
      if (res.data) {
        set支払先コード(res.data.支払先コード)
        set支払先区分コード(
          res.data.支払先区分コード ? res.data.支払先区分コード : ""
        )
        set支払先名(res.data.支払先名)
        set支払先略称(res.data.支払先略称)
        set郵便番号(res.data.郵便番号)
        set住所１(res.data.住所１)
        set住所２(res.data.住所２)
        set住所３(res.data.住所３)
        set電話番号(res.data.電話番号)
        setFAX番号(res.data.FAX番号)
        set支払先担当者(res.data.支払先担当者)
        setインボイス登録番号(res.data.インボイス登録番号)
        set最終更新日時(res.data.更新日時)
        set最終更新ID(
          res.data.更新ユーザID ? res.data.更新ユーザID.toString() : ""
        )
      }
    } catch (error) {
      disPatch(setAlerts(error))
    }
  }

  const getPostReq = (): TSiharaisakiRegisterPostReq => {
    return {
      支払先コード: 支払先コード ?? "",
      支払先区分コード: 支払先区分コード ?? "",
      支払先名: 支払先名 ?? "",
      支払先略称,
      郵便番号,
      住所１,
      住所２,
      住所３,
      電話番号,
      FAX番号,
      支払先担当者,
      インボイス登録番号,
    }
  }

  const getPutReq = (): TSiharaisakiUpdatePutReq => {
    return {
      支払先コード: 支払先コード ?? "",
      支払先区分コード: 支払先区分コード ?? "",
      支払先名: 支払先名 ?? "",
      支払先略称,
      郵便番号,
      住所１,
      住所２,
      住所３,
      電話番号,
      FAX番号,
      支払先担当者,
      インボイス登録番号,
      更新日時: 最終更新日時 ? 最終更新日時.toString() : "",
    }
  }

  /**
   * 送信前バリデーションチェックなど
   */
  const beforeSubmit = () => {
    const ajv = new Ajv({ allErrors: true })
    ajvErrors(ajv)
    let schema
    let data
    if (id) {
      schema = TSiharaisakiUpdatePutReqSchema
      data = getPutReq()
    } else {
      schema = TSiharaisakiRegisterPostReqSchema
      data = getPostReq()
    }
    const validate = ajv.compile(schema)
    const validateResult = validate(data)
    if (!validateResult) {
      const errors = validate.errors
      const errorMessages: string[] = []
      if (errors != null && errors.length > 0) {
        //エラーメッセージのparamsより対象の項目を発見し色変え
        setValidateError(errors)
        errorMessages.push(
          ...errors.filter((e) => e.message != null).map((e) => e.message ?? "")
        )
      }
      disPatch(setWarningAlerts([...errorMessages]))
      return
    }

    setIsConfirmModalShow(true)
  }

  /**
   * エラー発生時の項目色変え
   * @param errors
   */
  const setValidateError = (
    errors: ErrorObject<string, Record<string, any>, unknown>[]
  ) => {
    const instancePaths = errors.map((e) => e.instancePath.replaceAll("/", ""))
    const requiredProperties = errors
      .filter(
        (e) =>
          e.instancePath === "" &&
          e.params.errors != null &&
          e.params.errors.length > 0 &&
          e.params.errors.find(
            (ec: { keyword: string }) => ec.keyword === "required"
          )
      )
      .map((e) => {
        const error = e.params.errors[0]
        return error.params.missingProperty
      })
    const errorProperties = [...instancePaths, ...requiredProperties]

    setIsInvalid支払先コード(errorProperties.includes("支払先コード"))
    setIsInvalid支払先区分コード(errorProperties.includes("支払先区分コード"))
    setIsInvalid支払先名(errorProperties.includes("支払先名"))
    setIsInvalid支払先略称(errorProperties.includes("支払先略称"))
    setIsInvalid郵便番号(errorProperties.includes("郵便番号"))
    setIsInvalid住所１(errorProperties.includes("住所１"))
    setIsInvalid住所２(errorProperties.includes("住所２"))
    setIsInvalid住所３(errorProperties.includes("住所３"))
    setIsInvalid電話番号(errorProperties.includes("電話番号"))
    setIsInvalidFAX番号(errorProperties.includes("FAX番号"))
    setIsInvalid支払先担当者(errorProperties.includes("支払先担当者"))
    setIsInvalidインボイス登録番号(
      errorProperties.includes("インボイス登録番号")
    )
  }

  /**
   * 送信
   */
  const submit = async () => {
    try {
      const service = new SiharaisakiService()

      let res: TApiResponse<boolean>
      if (id) {
        res = await service.put(id, getPutReq())
      } else {
        res = await service.post(getPostReq())
      }
      disPatch(setAlerts(res))
      if (res) {
        isPrompt.current = false
        history.goBack()
        showInfoToast(`支払先マスタの${id ? "更新" : "登録"}が完了しました`)
      }
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
    }
  }
  //#endregion

  //#region [effect]

  //初期設定
  useEffect(() => {
    //画面全体ロック
    disPatch(画面ロック開始())

    Promise.all([new KubunService().getList()]).then(([区分マスタRes]) => {
      区分マスタRes && set区分ItemSource(区分マスタRes.data)

      // id存在時はデータを取得し更新
      if (id) {
        getData(id).finally(() => {
          disPatch(画面ロック解除())
        })
        // ファイルロード後、戻るボタン押下時に警告が出るように変更
        isPrompt.current = !読取専用フラグ
      } else {
        disPatch(画面ロック解除())
        // ファイルロード後、戻るボタン押下時に警告が出るように変更
        isPrompt.current = !読取専用フラグ
      }
    })
  }, [])

  //#endregion

  return (
    <>
      <Prompt
        when={isPrompt.current}
        message={CONSTANT.MESSAGES.BROWSER_BACK}></Prompt>
      <Container fluid>
        {/* 画面タイトル */}
        <Row className="page-title-row">
          <Col className="page-title-col">
            <span className="page-title">
              支払先マスタ{id ? `更新` : `登録`}
            </span>
          </Col>
        </Row>
        {/* アラート表示 */}
        <Row>
          <Col>
            <AlertComponent />
          </Col>
        </Row>
        <Row>
          <Col>
            {/* 検索条件カード */}
            <Card className="w-75rem">
              <Card.Body>
                <Container fluid className="register-form">
                  {/* 支払先コード */}
                  <MasterRegisterFormRow
                    label="支払先コード"
                    isRequired={true}
                    remarks={<div>半角英数字5桁まで</div>}>
                    <div className="w-6rem">
                      <TextInput
                        id="支払先コード"
                        name="支払先コード"
                        value={支払先コード}
                        setValue={set支払先コード}
                        maxLength={10}
                        className={isInvalid支払先コード ? "is-error" : ""}
                      />
                    </div>
                  </MasterRegisterFormRow>
                  {/* 支払先区分 */}
                  <MasterRegisterFormRow label="支払先区分" isRequired={true}>
                    <ComboBox.Kubun
                      分類コード={区分分類コード.マスタ.支払先区分}
                      isLoadEnded={支払先区分IsLoadEnded}
                      setIsLoadEnded={set支払先区分IsLoadEnded}
                      isAllSelect={false}
                      isRequired={true}
                      isEmpty={true}
                      itemsSource={区分ItemSource}
                      selectedValue={支払先区分コード}
                      setSelectedValue={set支払先区分コード}
                      ComboBox={支払先区分ComboBox}
                      setComboBox={set支払先区分ComboBox}
                      className={
                        isInvalid支払先区分コード ? "is-error" : ""
                      }></ComboBox.Kubun>
                  </MasterRegisterFormRow>
                  {/* 支払先名 */}
                  <MasterRegisterFormRow label="支払先名" isRequired={true}>
                    <div className="w-15rem">
                      <TextInput
                        id="支払先名"
                        name="支払先名"
                        value={支払先名}
                        setValue={set支払先名}
                        maxLength={100}
                        className={isInvalid支払先名 ? "is-error" : ""}
                      />
                    </div>
                  </MasterRegisterFormRow>
                  {/* 略名 */}
                  <MasterRegisterFormRow label="略名">
                    <div className="w-15rem">
                      <TextInput
                        id="支払先略称"
                        name="支払先略称"
                        value={支払先略称}
                        setValue={set支払先略称}
                        maxLength={100}
                        className={isInvalid支払先略称 ? "is-error" : ""}
                      />
                    </div>
                  </MasterRegisterFormRow>
                  {/* 郵便番号 */}
                  <MasterRegisterFormRow
                    label="郵便番号"
                    remarks={<div>ハイフンあり で入力してください</div>}>
                    <TextInput
                      id="郵便番号"
                      name="郵便番号"
                      value={郵便番号}
                      setValue={set郵便番号}
                      maxLength={100}
                      placeholder="郵便番号"
                      className={isInvalid郵便番号 ? "is-error" : ""}
                    />
                  </MasterRegisterFormRow>
                  {/* 住所１ */}
                  <MasterRegisterFormRow label="住所１">
                    <TextInput
                      id="住所１"
                      name="住所１"
                      value={住所１}
                      setValue={set住所１}
                      maxLength={100}
                      placeholder="都道府県"
                      className={isInvalid住所１ ? "is-error" : ""}
                    />
                  </MasterRegisterFormRow>
                  {/* 住所２ */}
                  <MasterRegisterFormRow label="住所２">
                    <TextInput
                      id="住所２"
                      name="住所２"
                      value={住所２}
                      setValue={set住所２}
                      maxLength={100}
                      placeholder="市区町村"
                      className={isInvalid住所２ ? "is-error" : ""}
                    />
                  </MasterRegisterFormRow>
                  {/* 住所３ */}
                  <MasterRegisterFormRow label="住所３">
                    <TextInput
                      style={{ width: "40rem" }}
                      id="住所３"
                      name="住所３"
                      value={住所３}
                      setValue={set住所３}
                      maxLength={100}
                      placeholder="町名番地"
                      className={isInvalid住所３ ? "is-error" : ""}
                    />
                  </MasterRegisterFormRow>
                  {/* 電話番号 */}
                  <MasterRegisterFormRow
                    label="電話番号"
                    remarks={<div>ハイフンあり で入力してください</div>}>
                    <TextInput
                      id="電話番号"
                      name="電話番号"
                      value={電話番号}
                      setValue={set電話番号}
                      maxLength={15}
                      className={isInvalid電話番号 ? "is-error" : ""}
                    />
                  </MasterRegisterFormRow>
                  {/* FAX番号 */}
                  <MasterRegisterFormRow
                    label="FAX番号"
                    remarks={<div>ハイフンあり で入力してください</div>}>
                    <TextInput
                      id="FAX番号"
                      name="FAX番号"
                      value={FAX番号}
                      setValue={setFAX番号}
                      maxLength={15}
                      className={isInvalidFAX番号 ? "is-error" : ""}
                    />
                  </MasterRegisterFormRow>
                  {/* 支払先担当者 */}
                  <MasterRegisterFormRow
                    label="支払先担当者"
                    isRequired={false}>
                    <TextInput
                      id="支払先担当者"
                      name="支払先担当者"
                      value={支払先担当者}
                      setValue={set支払先担当者}
                      maxLength={100}
                      className={isInvalid支払先担当者 ? "is-error" : ""}
                    />
                  </MasterRegisterFormRow>
                  {/* インボイス登録番号 */}
                  <MasterRegisterFormRow
                    label="インボイス登録番号"
                    remarks={<div>適格請求書発行事業者の登録番号</div>}>
                    <TextInput
                      id="インボイス登録番号"
                      name="インボイス登録番号"
                      value={インボイス登録番号}
                      setValue={setインボイス登録番号}
                      maxLength={20}
                      className={isInvalidインボイス登録番号 ? "is-error" : ""}
                    />
                  </MasterRegisterFormRow>
                </Container>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        {id && (
          <>
            <Row>
              <Col>
                最終更新日時:
                {util.date.format(最終更新日時, "YYYY/MM/DD HH:mm:ss")}
              </Col>
            </Row>
            <Row>
              <Col>最終更新ID : {最終更新ID}</Col>
            </Row>
          </>
        )}
        <Row className="search-button">
          {!読取専用フラグ && (
            <Col xl={{ span: "auto", offset: 0 }}>
              <Button
                variant="waiting"
                type="submit"
                onClick={(e) => {
                  e.stopPropagation()
                  e.preventDefault()
                  beforeSubmit()
                }}>
                {id ? `更新` : `登録`}
              </Button>
            </Col>
          )}
          <Col>
            <Button
              type="button"
              variant="secondary"
              onClick={() => history.goBack()}>
              一覧に戻る
            </Button>
          </Col>
        </Row>
      </Container>
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={submit}>
        入力された内容で{id ? "更新" : "登録"}しますか？
      </ConfirmModal>
    </>
  )
}

export default MasterSiharaisakiRegister
